<template>
  <v-col cols="12" sm="6" md="4" lg="3" xl="2">
    <v-card tile height="100%" @click="deviceDetail()">
      <v-card-title>
        <v-layout justify-space-between class="ma-0 pa-0">
          <h2 :class="!deviceOffline ? 'textPrimary': 'textGray'">{{ device.name }}</h2>
          <v-icon v-if="showAlarm" color="error">mdi-alert</v-icon>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout justify-center style="height:145px;">
          <div :class="bgImage"></div>
        </v-layout>
        <v-layout v-if="device.data.sae" class="ma-2 text-center">
          {{ $t("device.is") }} {{ ($t("common.status1." + device.data.sae.s1)).toUpperCase() }}
        </v-layout>
        <v-layout class="ma-2 text-center">
          {{ $t("device.environment") }}: {{ temp }}{{ $t('common.unit.temp') }} {{ hum }}{{ $t('common.unit.hum') }}
        </v-layout>
        <v-layout v-if="device.data.sae" class="ma-2 text-center">
          {{ $t("device.output") }}: {{ device.data.sae.vout }}{{ $t('common.unit.v') }} {{ device.data.sae.iout }}{{ $t('common.unit.i') }} {{ device.data.sae.hzout }}{{ $t('common.unit.hz') }}
        </v-layout>
        <v-layout v-if="alarmsItems.length > 0" class="error--text ma-2 mt-6">
          <strong>{{ $t('device.alarms') }}</strong>
        </v-layout>
        <v-layout v-for="alarm in alarmsItems" :key="alarm.name" class="error--text ma-2">
          {{ $t("device.alarm." + alarm.name) }}
        </v-layout>
        <v-divider></v-divider>
        <v-row class="ma-2 d-flex justify-center">
          {{ updateTimestamp }}
        </v-row>
      </v-card-text>    
    </v-card>
  </v-col>
</template>

<script>
import { mapActions } from "vuex"

export default {
  props: ["device"],
  data() {
    return {
      treeshold: 60, // seconds
      deviceOffline: false
    }
  },
  mounted() {
    var _this = this
    this.checkDeviceTimeout()
    setInterval(() => _this.checkDeviceTimeout() , 10000);
  },
  watch: {
    updateTimestamp(newvalue) {
      if (newvalue) {
        this.deviceOffline = false
      }
    }
  },
  computed: {
    bgImage() {
      return this.deviceOffline ? 'imageOffline imgContainer' : 'imageOnline imgContainer'
    },
    deviceImage() {
      return this.deviceOffline ? 'img/offline.svg' : 'img/connected.png'
    },
    showAlarm() {
      this.$log.debug(this.device)
      if (this.device.data.uptime.serial == false)
        return true
      if (this.device.data.sae)
        return Object.values(this.device.data.sae.alarm).some(a => a == true)
      return false
    },
    alarmsItems() {
      let alarm = []
      if (this.device.data.uptime.serial == false)
        alarm.push({name: "serial", value: true})
      if (this.device.data.sae) {
        Object.keys(this.device.data.sae.alarm).forEach(key => {
          let v = this.device.data.sae.alarm[key]
          if (v)
            alarm.push({name: key, value: v})
        });
      }
      return alarm;
    },
    updateTimestamp() {
      let timestamp = this.device.data.timestamp ? this.longDateMixin(this.device.data.timestamp) : "-"
      return this.$i18n.t("device.lastupdate") + ": " + timestamp
    },
    temp() {
      return this.device.data.sensors.ambient?.temp ?? ''
    },
    hum() {
      return this.device.data.sensors.ambient?.hum ?? ''
    }
  },
  methods: {
    ...mapActions(["doGetDevice", "doGetAlarmsState"]),
    async deviceDetail() {
      await Promise.all([
        this.doGetDevice(this.device.name),
      ])
      this.doGetAlarmsState(this.device.name)
      this.$router.push({ name: "device", params: { id: this.device.name } })
    },
    checkDeviceTimeout() {
      let lastUpdate = this.device.data.timestamp
      if (lastUpdate) {
        let interval = (new Date() - new Date(lastUpdate))/1000
        this.deviceOffline = interval > this.treeshold
      }
      else {
        this.deviceOffline = true
      }
    }
  }
}
</script>

<style scoped>
.textPrimary {
  color: var(--v-primary-base) !important
}
.textGray {
  color: var(--v-accent-lighten1) !important
}

.imageOffline {
  background-image: url('/img/offline.svg');
}
.imageOnline {
  background-image: url('/img/connected.png');
}
.imgContainer {
  background-size: contain;
  width: 90%;
  height: 100%;
  background-position: center center;
}
</style>